import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const useSignOut = () => {
  const handleSignOut = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/logout`, {
        withCredentials: true,
      });

      if (response.status === 200) {
        // toast.success("Signed out successfully");
      } else {
        toast.error("Server failed to log out");
      }
    } catch (error) {
      toast.error("Failed to sign out. Please try again.");
    } finally {
      // Always clear storage and redirect
      localStorage.clear();
      sessionStorage.clear();
    }
  };

  return handleSignOut;
};
